// extracted by mini-css-extract-plugin
export default {"fadeOutR":"FeatureSection_fadeOutR__G4UOP","fadeOutL":"FeatureSection_fadeOutL__kaOh6","fadeIn":"FeatureSection_fadeIn__RA95j"};